import { render } from "./OldRecords.vue?vue&type=template&id=a3d8d50e"
import script from "./OldRecords.vue?vue&type=script&lang=js"
export * from "./OldRecords.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__